$.fn.popover.Constructor.prototype.setContent = function () {
    var a = this.tip(), b = this.getTitle(), c = this.getContent();
    a.find(".popover-title")[this.options.html ? "html" : "text"](b),
        a.find(".popover-content")[this.options.html ? "html" : "text"](c), // <-- changed in this line
        a.removeClass("fade top bottom left right in"),
    a.find(".popover-title").html() || a.find(".popover-title").hide();
};
